import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IFilter } from '../../interfaces/ifilter';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IFilterDataResponse } from '../../interfaces/ifilter-event';
import { DatePipe } from '@angular/common';
import {FilterModel, IFilterData, IFilterModel } from '../../models/filter-model';
import { FilterService, IFilterSubject } from '../../services/filter.service';
import { filter } from 'rxjs';



export type IDataFilterRangeDate = [Date?, Date?];




@Component({
  selector: 'split-filter-range-date',
  templateUrl: './split-filter-range-date.component.html',
  styleUrls: ['./split-filter-range-date.component.scss']
})
export class SplitFilterRangeDateComponent implements OnChanges, OnInit {

  @Input() data: IFilterData[] = [];

  @Input() field!: string;

  @Input() label!: string;

  @Input() key!: string;
  @Input() groupId!: string;

  protected _data: IDataFilterRangeDate = [];

  protected filterModel!: IFilterModel;


  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  @ViewChild('op') public overlayPanel!: OverlayPanel;
  isActiveOverlay: boolean = false;

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.filters = this.filterModel;

    this.filterService.filterSubject.pipe(
      filter((data: IFilterSubject) => data.action === "CLEAR"),
      filter((event: IFilterSubject) => event.id === this.groupId)
    ).subscribe(
      (data: IFilterSubject) => {
        this._data = [];
        this.onEmit();
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
   if(changes["data"]) {
     this._data = this.copy();
   }  

   if(changes["key"]) {
    this.filterModel = {
      id: this.groupId,
      type: "DATE",
      key: this.key,
      data: [],
      filter: []
    }
   }
  }

  copy() {
    console.log(this.data);
    return this.data.map((item) => new Date(item.name)) as IDataFilterRangeDate;
  }

  showOverlayPanel(event: any) {
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  hideOverlayPanel() {
    this._data = this.copy();
    this.isActiveOverlay = false;
  }

  onCancel() {
    this._data = [];
    this.onEmit();
    this.overlayPanel.hide();
  }

  onEmit() { 
    let filter: IFilter[] = [];
    let data: IFilterData[] = [];
    if(this._data.length > 0) {
      data = [{id: "after", name: this._data[0]}, {id: "before", name: this._data[1]}] as IFilterData[];
      filter = [
        {
          key: this.key,
          fields: ["after"],
          property: this.field,
          value: this.tranformDateInString(this._data[0])
        },
        {
          key: this.key,
          fields: ["before"],
          property: this.field,
          value: this.tranformDateInString(this._data[1])
        }
      ];
    }

    let filterModel: IFilterModel  = {
      ...this.filterModel,
      data: data,
      filter: filter
    };
    this.data = filterModel.data;
    this.filterService.send(filterModel);
    this.onFilterEvent.emit(filterModel);
    this.overlayPanel.hide();
  }

  onInput(event: any, position: number) {
    let [day, month, year] = event.target.value.split('/');
    let date = new Date(year, (month - 1), day);
    if(this.isValidDate(date)) {
      this._data[position] = date;
    } else {
      this._data[position] = undefined;
    }
  }

  tranformDateInString(date?: Date) {
    return new DatePipe("pt-BR").transform(date, 'yyyy-MM-dd') as string;
  }

  isValidDate(date: Date){
    return date.toString() !== 'Invalid Date';
  }
}
